module.exports = __webpack_public_path__ + "img/browser_mobilesafari.5d2a122c.svg";